import { Typography } from "@mui/material";
import React from "react";

import {
  Legend,
  Scatter,
  ScatterChart,
  XAxis,
  YAxis,
  ReferenceLine,
  Label,
} from "recharts";

const ScatterGraph = ({ passageData, student_id, isDefault, student_name, languageId }) => {
  let xmax = -Infinity; // Initialize to the smallest possible number
  let ymax = -Infinity; // Initialize to the smallest possible number

  passageData?.sittingData?.forEach((s) => {
    const speed = Math.ceil(Math.abs(s.speed));
    const correct = Math.ceil(Math.abs(s.correct));

    if (speed > xmax) xmax = speed;
    if (correct > ymax) ymax = correct;
  });

  const CustomXAxisTick = (value) => {
    if (value === xmax - 0.5) return `(${languageId === 2 ? "快點" : "faster"})`;
    if (value === xmax * -1 + 0.5) return `(${languageId === 2 ? "慢點" : "slower"})`;
    if (value === 0) return `(${languageId === 2 ? "平均的" : "Avg"})`;
    return "";
  };

  const CustomYAxisTick = (value) => {
    if (value === 0) return `(${languageId === 2 ? "平均的" : "Avg"})`;
    return "";
  };

  const CustomizedDot = ({ cx, cy, studentId }) => {
    if (studentId === student_id) {
      return <circle cx={cx} cy={cy} r={8} fill="#c10015" />;
    } else {
      return <circle cx={cx} cy={cy} r={3} fill="lightsteelblue" />;
    }
  };

  return (
    passageData &&
    student_id && (
      <>
        <ScatterChart
          width={500}
          height={500}
          margin={{
            top: 30,
            right: 0,
            left: 20,
            bottom: 20,
          }}
        >
          <text
            x={560 / 2}
            y={10}
            fill="black"
            textAnchor="middle"
            dominantBaseline="central"
          >
            <tspan fontSize={20} fontWeight="bold">
              {passageData?.name}
            </tspan>
          </text>
          <XAxis
            type="number"
            dataKey="speed"
            domain={[-1 * xmax, xmax]}
            tickSize={0}
            tickCount={xmax * 4 + 1}
            allowDecimals={true}
            tickFormatter={CustomXAxisTick}
            strokeWidth={4}
            stroke="black"
          >
            <Label
              value={`${languageId === 2 ? "速度" : "Speed"}`}
              position="insideBottom"
              offset={-10}
              fill="black"
              fontSize={20}
              fontWeight="bold"
            />
          </XAxis>
          <YAxis
            type="number"
            dataKey="correct"
            name="Questions Correct"
            domain={[-1 * ymax, ymax]}
            tickSize={0}
            tickCount={ymax * 4 + 1}
            tickFormatter={CustomYAxisTick}
            allowDecimals={true}
            strokeWidth={4}
            stroke="black"
          >
            <Label
              value={`${languageId === 2 ? "表現" : "Performance"}`}
              angle={-90}
              fill="black"
              fontSize={20}
              fontWeight="bold"
              position="insideLeft"
              offset={languageId === 2 ? -10 : 0}
            />
          </YAxis>
          <Legend
            payload={[
              { id: "ID01", value: `${languageId === 2 ? "你" : "You"}`, type: "circle", color: "#c10015" },
              {
                id: "ID02",
                value: `${languageId === 2 ? "其他學生" : "Other Students"}`,
                type: "circle",
                color: "lightsteelblue",
              },
            ]}
            wrapperStyle={{ position: "relative" }}
          />
          <ReferenceLine
            x={0}
            stroke="grey"
            isFront={false}
            strokeDasharray="5 3"
          />
          <ReferenceLine
            y={0}
            stroke="grey"
            isFront={false}
            strokeDasharray="5 3"
          />
          <ReferenceLine x={xmax} stroke="black" isFront={false} />
          <ReferenceLine y={ymax} stroke="black" isFront={false} />
          <Scatter data={passageData?.sittingData} shape={<CustomizedDot />}>
          </Scatter>
        </ScatterChart>
        {isDefault && (
          <>
            <br />
            <Typography>
              {languageId === 2 ? `
                由於資料不足，無法確定${student_name}的${passageData?.name}能力。因此，假定其能力為平均水準。 
              ` : `
                There was not enough data to determine ${student_name}'s${" "}
                ${passageData?.name} ability. As a result their ability was assumed
                to be average.
              `}
              
            </Typography>
          </>
        )}
      </>
    )
  );
};

export default ScatterGraph;
